window.pages["productlines.index"] = {
    page: document.body.getAttribute('page'),
    init: function () {
        // console.log(`[LARAVEL] Page initialized: ${this.page}`);
        window.components.questions.init();
        window.components.faq.init();
        window.components.accordionItem.init();
        window.components.modalPopup.init();

    
        $(function () {
            


            const pathname = $(location).attr('pathname');
            if (pathname == '/linha-de-produtos/bebida-uht') {
                $('.uht').show();
                $('.line-products-list').hide();
                $('.cloud-1').addClass('cloud-uht-1');
                $('.cloud-2').addClass('cloud-uht-2');
                $('.cloud-3').addClass('cloud-uht-3');
                $('.cloud-no-uht').hide();
                $('.bird-step').hide;

            } else {
                $('.uht').hide()
                $('.line-products-list').show()
                $('.cloud-no-uht').show()
                $('.bird-step').show;

            }


            function getRightContent(productId) {
                $('.right-content').html("<p>Carregando...</p>");
                $.get(`/linha-de-produtos/produto/${productId}`, function (data) {
                    $('.right-content').html(data);
                });
            }

            function getCurrentProductId() {
                const productId = $(".slick-current .product-container").data('productid');
                getRightContent(productId);

            }
            $(".nutritional-info .left-content").slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: true,
                fade: false,
                prevArrow: `<button class="left-arrow"><span class="material-icons-outlined">chevron_left</span></button>`,
                nextArrow: `<button class="right-arrow"><span class="material-icons-outlined">chevron_right</span></button>`,
            });

            getCurrentProductId();
            $(".nutritional-info .left-content").on('afterChange', function (event, slick, currentSlide,
                nextSlide) {
                getCurrentProductId();
            });
            if (window.matchMedia("(min-width: 769px)").matches) {
                

                $('.target-zoom').each((i, el) => {
                    $(el).attr('data-id', i)
                    $('.imagezoom').append('<div class="zoom-content" data-id="' + i + '" style="width: 95%; height: 400px; display:none; background-repeat:no-repeat; background-image:url(' + $(el).attr('data-src') + ')"></div>')
                });
                $('.target-zoom').on('mousemove', (ev) => {
                    $('.imagezoom').css('background-color', '#FFF');
                    $('.imagezoom').css('z-index', '9999');
                    const rect = ev.target.getBoundingClientRect();
                    const id = $(ev.target).attr('data-id')
                    const x = ev.clientX - rect.left;
                    const y = ev.clientY - rect.top;
                    $('.zoom-content[data-id="' + id + '"]').show();
                    $('.zoom-content[data-id="' + id + '"]').css('background-position-x', '-' + x + 'px')
                    $('.zoom-content[data-id="' + id + '"]').css('background-position-y', '-' + y + 'px')
                });
                $('.target-zoom').on('mouseleave', (ev) => {
                    const id = $(ev.target).attr('data-id')
                    $('.zoom-content[data-id="' + id + '"]').hide();
                    $('.imagezoom').css('background-color', 'transparent');
                    $('.imagezoom').css('z-index', '0');

                });
            } else {
                
                $("a[rel=modal]").click(function (ev) {
                    ev.preventDefault();
                    console.log('teste')
                    const img = $(this).children("img").attr("src");
                    const alt = $(this).children("img").attr("alt");
                    $('.window img').attr('src',img);
                    $('.window img').attr('alt',alt);
    
                    var id = $(this).attr("href");
    
                   
    
                    //colocando o fundo preto
                    
                    $('#mascara').fadeIn(1000);
                    $('#mascara').fadeTo("slow", 0.8);   
                    
    
                    
                    $(id).show();
                });
    
                $("#mascara").click(function () {
                    $(this).hide();
                    $(".window").hide();
                    $('.window img').attr('src','');
                    $('.window img').attr('alt','');
                });
    
                $('.fechar').click(function (ev) {
                    ev.preventDefault();
                    $("#mascara").hide();
                    $(".window").hide();
                    $('.window img').attr('src','');
                    $('.window img').attr('alt','');
                });
            }


            var demoTrigger = $('.product-container');
















        });
    },
};


